import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalContentComponent } from './components/modal-content/modal-content.component';
import { PnButtonComponent } from './components/elements/pn-button/pn-button.component';
import { PnInputComponent } from './components/elements/pn-input/pn-input.component';
import { PnCheckboxComponent } from './components/elements/pn-checkbox/pn-checkbox.component';
import { PnSpinnerComponent } from './components/elements/pn-spinner/pn-spinner.component';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChartsModule } from 'ng2-charts';
import { CustomOptionsComponent } from './components/custom-options/custom-options.component';

import { BodymodelService } from './services/bodymodel.service';
import { BaselineService } from './services/baseline.service';
import { InterventionService } from './services/intervention.service';
import { DailyparamsService } from './services/dailyparams.service';
import { BodychangeService } from './services/bodychange.service';
import { RegisterService } from './services/register.service';
import { ConfigService } from './services/config.service';
import { SliderLimitsDirective } from './directives/slider-limits.directive';
import { ModalErrorComponent } from './components/modal-error/modal-error.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { HttpClientModule } from '@angular/common/http';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { FileSaverModule } from 'ngx-filesaver';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { APP_BASE_HREF } from '@angular/common';

const RECAPTCHA_V3_SITE_KEY_PROD = '6LciDFclAAAAABlkaV_weygtKT0n2Htm6CU7yREy';
const RECAPTCHA_V3_SITE_KEY_DEV_AND_STAGING = '6LcGulolAAAAAEEl5Uk0u7ujy9O1YxOmkJ-mqVc4';
const recaptchaUseValue = window.location.origin === 'https://my.precisionnutrition.com' ? RECAPTCHA_V3_SITE_KEY_PROD : RECAPTCHA_V3_SITE_KEY_DEV_AND_STAGING;

@NgModule({
  declarations: [
    AppComponent,
    CalculatorComponent,
    ModalContentComponent,
    CustomOptionsComponent,
    PnButtonComponent,
    PnCheckboxComponent,
    PnInputComponent,
    PnSpinnerComponent,
    SliderLimitsDirective,
    ModalErrorComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    NgbModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    ChartsModule,
    FontAwesomeModule,
    HttpClientModule,
    RecaptchaV3Module,
    FileSaverModule,
    ReactiveFormsModule,
    AppRoutingModule,
  ],
  providers: [
    MatNativeDateModule,
    BodymodelService,
    BaselineService,
    InterventionService,
    DailyparamsService,
    BodychangeService,
    RegisterService,
    ConfigService,
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: recaptchaUseValue },
    { provide: Window, useValue: window },
    { provide: APP_BASE_HREF, useValue: '/nutrition_calculator/' },
  ],
  bootstrap: [AppComponent],
  entryComponents: [ModalContentComponent, ModalErrorComponent],
  exports: [],
})
export class AppModule {}
